var exports = {
  "e6": "AddFavoriteChannelModal.module__selectContainer___UzdvX0",
  "yc": "AddFavoriteChannelModal.module__checkboxRow___UzdvX0",
  "Dq": "AddFavoriteChannelModal.module__checkboxText___UzdvX0",
  "gs": "AddFavoriteChannelModal.module__scrollerContainer___UzdvX0",
  "o5": "AddFavoriteChannelModal.module__channelList___UzdvX0",
  "p$": "AddFavoriteChannelModal.module__emptyState___UzdvX0",
  "Km": "AddFavoriteChannelModal.module__categoryHeader___UzdvX0",
  "WG": "AddFavoriteChannelModal.module__channelRow___UzdvX0",
  "uM": "AddFavoriteChannelModal.module__channelIconContainer___UzdvX0",
  "p": "AddFavoriteChannelModal.module__channelIcon___UzdvX0",
  "HA": "AddFavoriteChannelModal.module__channelName___UzdvX0",
  "tN": "AddFavoriteChannelModal.module__channelActions___UzdvX0",
};

module.exports = exports;
